var axios = require('axios');
var { error_message } = require('@managers/helpers');

const SCIROOT_WEATHER_RECORDS_PATH = 'weather_records';

// Implementation lives in utils/ so it can be unit-tested with `node --test`.
export var weatherDataStatistics =
  require('../utils/weatherDataStatistics').weatherDataStatistics;

export var deleteWeatherRecord = (source, startDate, recordType) => {
  return new Promise(function (resolve, reject) {
    axios
      .delete(
        SCIROOT_WEATHER_RECORDS_PATH +
          '/' +
          source +
          '?startDate=' +
          startDate +
          '&recordType=' +
          recordType,
        {}
      )
      .then(function (res) {
        resolve(res.data);
      })
      .catch(function (err) {
        console.log(error_message(err));
        reject(err);
      });
  });
};
